import { DEFAULT_BASE_LAYOUT_CONFIG } from '../constants/default-layout-config'
import { BASE_AR_TAB_ID, BASE_AR_TAB_LABEL } from '../constants/base-tab-links'
import { BaseLayoutConfig, BASE_LAYOUT_VERSION, BaseLayoutTab } from '../types/base-layout'

const EMPTY_AR_TAB: BaseLayoutTab = {
  id: BASE_AR_TAB_ID,
  label: BASE_AR_TAB_LABEL,
  sections: [],
}

export function resolveBaseLayoutConfig(
  config: unknown,
): BaseLayoutConfig {
  if (!config || typeof config !== 'object') {
    return DEFAULT_BASE_LAYOUT_CONFIG
  }

  const parsed = config as Partial<BaseLayoutConfig>

  if (!parsed.tabs || !Array.isArray(parsed.tabs)) {
    return DEFAULT_BASE_LAYOUT_CONFIG
  }

  return {
    version: parsed.version ?? BASE_LAYOUT_VERSION,
    tabs: parsed.tabs.map((tab, index) => ({
      id: tab?.id ?? `tab-${index}`,
      label: tab?.id === BASE_AR_TAB_ID ? BASE_AR_TAB_LABEL : (tab?.label ?? `Tab ${index + 1}`),
      sections: Array.isArray(tab?.sections)
        ? tab.sections.map((section, sectionIdx) => ({
            id: section?.id ?? `section-${index}-${sectionIdx}`,
            type: section?.type ?? 'custom',
            title: section?.title,
            options: section?.options,
            content: typeof section?.content === 'string' ? section.content : undefined,
          }))
        : [],
    })),
  }
}

export function omitArTabFromLayout(config: BaseLayoutConfig): BaseLayoutConfig {
  return {
    ...config,
    tabs: config.tabs.filter((tab) => tab.id !== BASE_AR_TAB_ID),
  }
}

/** Keep a permanent AR tab last among configurable Hub tabs. */
export function ensurePermanentArTab(config: BaseLayoutConfig): BaseLayoutConfig {
  const existingAr = config.tabs.find((tab) => tab.id === BASE_AR_TAB_ID)
  const customTabs = config.tabs.filter((tab) => tab.id !== BASE_AR_TAB_ID)

  return {
    ...config,
    tabs: [
      ...customTabs,
      {
        ...EMPTY_AR_TAB,
        ...existingAr,
        id: BASE_AR_TAB_ID,
        label: BASE_AR_TAB_LABEL,
        sections: existingAr?.sections ?? [],
      },
    ],
  }
}

export function addConfigurableHubTab(
  config: BaseLayoutConfig,
  tab: BaseLayoutTab,
): BaseLayoutConfig {
  return ensurePermanentArTab({
    ...config,
    tabs: [...config.tabs, tab],
  })
}

